
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import {MDXRemoteSerializeResult} from 'next-mdx-remote'
import useTranslation from 'next-translate/useTranslation'
import {serialize} from 'next-mdx-remote/serialize'
import Heading from '../components/atoms/heading'
import HighlightedSection from '../components/atoms/highlighted-section'
import LoadableImage from '../components/atoms/loadable-image'
import Container from '../components/atoms/container'
import {GridContainer} from '../components/atoms/grid-container'
import CallToAction from '../components/molecules/call-to-action'
import PartnerCard from '../components/molecules/partner-card/partner-card'
import PageCover from '../components/organisms/page-cover'
import PageLayout from '../layouts/page-layout'
import {FooterDataStateProps, FooterProvider} from '../contexts/footer-context'
import fetchGeneralSettings from '../lib/fetch-general-settings'
import fetchSocialLinks from '../lib/fetch-social-links'
import fetchPartnersData from '../lib/fetch-partners-data'
import {PartnersDataProps} from '../lib/fetch-partners-data'
import mapRawPartnerToPartner from '../lib/map-raw-partner-to-partner/map-raw-partner-to-partner'
import parseFrontMatter from '../lib/parse-front-matter'
import bishopSymbol from '../public/assets/bishop-logo-symbol.png'
import {GridItem} from '../components/atoms/grid-item'
import {getPlaiceholder} from 'plaiceholder'
import {PageCoverTitle} from '../components/molecules/page-cover-title'

export default function Partners({
  coverDescription,
  metaDescription,
  previewImage,
  coverPhoto,
  coverPhotoAlt,
  partners,
  social,
  general,
}: PartnersDataProps<MDXRemoteSerializeResult> & FooterDataStateProps) {
  const {t} = useTranslation('partners')

  return (
    <FooterProvider value={{social, general}}>
      <PageLayout
        className="grid grid-flow-row gap-16 md:gap-24 pt-24 lg:pt-10 pb-12 md:pb-24"
        disableDefaultPadding
        title={t('title')}
        description={metaDescription}
        openGraph={{
          images: [{url: previewImage || bishopSymbol.src}],
          url: 'partners',
        }}
        prefixImageUrl={!previewImage}
      >
        <div>
          <PageCover
            className="sm:min-h-180"
            title={
              <PageCoverTitle
                text={[
                  [
                    {text: t('page-title.we-dont')},
                    {
                      text: t('page-title.clients'),
                      className: 'gradient-orange',
                    },
                  ],
                  [
                    {text: t('page-title.we-have')},
                    {
                      text: t('page-title.partners'),
                      className: 'gradient-blue',
                    },
                  ],
                ]}
                fontSize="text-5xl"
              />
            }
            description={coverDescription}
            media={
              <LoadableImage
                src={coverPhoto}
                alt={coverPhotoAlt}
                layout="responsive"
                width={650}
                height={460}
                objectFit="cover"
                borderRadius="rounded-none sm:rounded-3xl"
                wrapperClassName="max-w-none sm:max-w-xl lg:max-w-none -mx-6 -mt-4 sm:mx-auto sm:mt-0"
                priority
              />
            }
          />
          <HighlightedSection>
            <Heading className="pt-8 pb-16" variant="h2">
              {t('partner-list-title')}
            </Heading>
            <GridContainer
              disableDefaultColumns
              className="flex flex-1 w-full grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-y-32"
            >
              {partners.map(partner => (
                <GridItem key={partner.name}>
                  <PartnerCard partner={partner} />
                </GridItem>
              ))}
            </GridContainer>
          </HighlightedSection>
        </div>
        <Container>
          <CallToAction
            title={t('contact.title')}
            callToActionText={t('common:navigation.contact-us')}
            href="/contact-us"
          >
            {t('contact.body')}
          </CallToAction>
        </Container>
      </PageLayout>
    </FooterProvider>
  )
}

 async function _getStaticProps() {
  const {
    coverPhoto,
    coverPhotoAlt,
    coverDescription: rawCoverDescription,
    partners,
    metaDescription,
    previewImage,
  } = fetchPartnersData()

  const coverDescription = await serialize(rawCoverDescription)

  const availablePartners = await Promise.all(
    partners.map(partner => import(`../content/partners/${partner}.md`)),
  )

  const mappedPartners = await Promise.all(
    availablePartners
      .map(content => parseFrontMatter<any>(content.default).attributes)
      .map(async ({logo, ...data}) => {
        const convertedLogo = await getPlaiceholder(logo)

        return mapRawPartnerToPartner({logo: convertedLogo, ...data})
      }),
  )

  return {
    props: {
      coverPhoto,
      coverPhotoAlt,
      coverDescription,
      metaDescription,
      previewImage,
      partners: mappedPartners,
      social: fetchSocialLinks(),
      general: fetchGeneralSettings(),
    },
  }
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/partners',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  